import axios from "axios";

export default class ApiService {
    basePath = '/api';

    constructor(basePath) {
        if (basePath !== null && basePath !== undefined) {
            this.basePath = basePath;
        }
    }

    get(path, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(this.basePath + path, {params})
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    post(path, data = {}) {
        return new Promise((resolve, reject) => {
            axios.post(this.basePath + path, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    update(path, data) {
        return new Promise((resolve, reject) => {
            axios.post(this.basePath + path, {...data, ...{_method: 'PUT'}})
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    delete(path) {
        return new Promise((resolve, reject) => {
            axios.delete(this.basePath + path)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    download(path, params = {}) {
        return new Promise((resolve, reject) => {
            axios({
                url: this.basePath + path,
                method: 'GET',
                responseType: 'blob',
                params,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].replace(/\"/g,""));
                document.body.appendChild(link);
                link.click();

                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    downloadPost(path, params = {}) {
        return new Promise((resolve, reject) => {
            axios({
                url: this.basePath + path,
                method: 'POST',
                responseType: 'blob',
                data: params,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].replace(/\"/g,""));
                document.body.appendChild(link);
                link.click();

                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
